
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Star, Quote } from "lucide-react";

export const TestimonialsSection = () => {
  return (
    <section className="py-12 md:py-16 lg:py-[60px] bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 dark:text-white mb-4">
            O que nossos clientes dizem
          </h2>
          <p className="text-base md:text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto px-4">
            Resultados reais de e-commerces que transformaram suas vendas
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 max-w-6xl mx-auto">
          <Card className="border-0 shadow-lg hover:shadow-xl transition-shadow bg-white dark:bg-gray-800 relative p-4 md:p-6">
            <CardHeader className="pb-4">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-r from-brand-teal to-brand-coral rounded-full flex items-center justify-center text-white font-bold text-sm md:text-lg">
                  M
                </div>
                <div>
                  <CardTitle className="text-base md:text-lg text-gray-900 dark:text-white">Marina Santos</CardTitle>
                  <p className="text-xs md:text-sm text-gray-600 dark:text-gray-400">Proprietária - Moda Bella</p>
                </div>
              </div>
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-3 w-3 md:h-4 md:w-4 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
            </CardHeader>
            <CardContent>
              <Quote className="h-6 w-6 md:h-8 md:w-8 text-brand-teal/20 mb-4" />
              <CardDescription className="text-sm md:text-base text-gray-700 dark:text-gray-300 italic">
                "Em 3 meses aumentamos 45% no faturamento. O programa de cashback fez nossos clientes comprarem mais e ainda trouxeram amigos. Simplesmente fantástico!"
              </CardDescription>
              <div className="mt-4 pt-4 border-t border-gray-200">
                <p className="text-xs md:text-sm font-semibold text-brand-teal">+45% de aumento no faturamento</p>
              </div>
            </CardContent>
          </Card>

          <Card className="border-0 shadow-lg hover:shadow-xl transition-shadow bg-white dark:bg-gray-800 relative p-4 md:p-6">
            <CardHeader className="pb-4">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-r from-brand-coral to-brand-teal rounded-full flex items-center justify-center text-white font-bold text-sm md:text-lg">
                  R
                </div>
                <div>
                  <CardTitle className="text-base md:text-lg text-gray-900 dark:text-white">Ricardo Oliveira</CardTitle>
                  <p className="text-xs md:text-sm text-gray-600 dark:text-gray-400">CEO - TechStore</p>
                </div>
              </div>
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-3 w-3 md:h-4 md:w-4 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
            </CardHeader>
            <CardContent>
              <Quote className="h-6 w-6 md:h-8 md:w-8 text-brand-coral/20 mb-4" />
              <CardDescription className="text-sm md:text-base text-gray-700 dark:text-gray-300 italic">
                "O programa de indicações triplicou nossas vendas orgânicas. Agora nossos próprios clientes vendem para nós. ROI incrível!"
              </CardDescription>
              <div className="mt-4 pt-4 border-t border-gray-200">
                <p className="text-xs md:text-sm font-semibold text-brand-coral">3x mais indicações</p>
              </div>
            </CardContent>
          </Card>

          <Card className="border-0 shadow-lg hover:shadow-xl transition-shadow bg-white dark:bg-gray-800 relative md:col-span-2 lg:col-span-1 p-4 md:p-6">
            <CardHeader className="pb-4">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-r from-brand-teal to-brand-coral rounded-full flex items-center justify-center text-white font-bold text-sm md:text-lg">
                  A
                </div>
                <div>
                  <CardTitle className="text-base md:text-lg text-gray-900 dark:text-white">Ana Costa</CardTitle>
                  <p className="text-xs md:text-sm text-gray-600 dark:text-gray-400">Fundadora - Beleza Natural</p>
                </div>
              </div>
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-3 w-3 md:h-4 md:w-4 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
            </CardHeader>
            <CardContent>
              <Quote className="h-6 w-6 md:h-8 md:w-8 text-brand-teal/20 mb-4" />
              <CardDescription className="text-sm md:text-base text-gray-700 dark:text-gray-300 italic">
                "A configuração foi super fácil e em 24h já víamos os primeiros resultados. Nossa taxa de retenção aumentou 60%!"
              </CardDescription>
              <div className="mt-4 pt-4 border-t border-gray-200">
                <p className="text-xs md:text-sm font-semibold text-brand-teal">+60% de retenção</p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};
